import { render, staticRenderFns } from "./PolicyDetails.vue?vue&type=template&id=5a581f8c&scoped=true"
import script from "./PolicyDetails.vue?vue&type=script&lang=ts"
export * from "./PolicyDetails.vue?vue&type=script&lang=ts"
import style0 from "./PolicyDetails.vue?vue&type=style&index=0&id=5a581f8c&lang=scss"
import style1 from "./PolicyDetails.vue?vue&type=style&index=1&id=5a581f8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a581f8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a581f8c')) {
      api.createRecord('5a581f8c', component.options)
    } else {
      api.reload('5a581f8c', component.options)
    }
    module.hot.accept("./PolicyDetails.vue?vue&type=template&id=5a581f8c&scoped=true", function () {
      api.rerender('5a581f8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policies/components/PolicyDetails.vue"
export default component.exports